import { render, staticRenderFns } from "./DictManage.vue?vue&type=template&id=586a6779&scoped=true&"
import script from "./DictManage.vue?vue&type=script&lang=js&"
export * from "./DictManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "586a6779",
  null
  
)

export default component.exports